import script from "./VMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VMessage.vue?vue&type=script&setup=true&lang=ts"

import "./VMessage.vue?vue&type=style&index=0&id=a2ea2b4e&scoped=true&lang=postcss"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2ea2b4e"]])

export default __exports__